import { Box, Button, FormButtonRow } from '@ksyos/design-system';
import { ProcessActivityStatus } from '@common/enums';
import { CustomControlCode } from '@common/enums/serviceWorkflow/customControlCode';
import { ProcessActivityReadContext } from '@frontend/components/pages/episodeCategory/carePath/process/processActivity/processActivityRead/processActivityReadContext';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { getProcessActivityHolterDiaryUrl } from '@frontend/services/api/processActivitiesApiService';
import { getSelectedLanguage } from '@frontend/translate';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';
import { HolterConfigureSuccessAlert } from '../customComponents/HolterConfigureSuccessAlert';
import { HolterExaminationFollowingSteps } from '../customComponents/HolterExaminationFollowingSteps';
import { getExaminationRequestReadComponentsBase } from '../utils/getExaminationRequestReadComponentsBase';

export function HolterDirectExaminationRequestRead(): JSX.Element {
    const { readSections, processActivity } = useDefinedContext(ProcessActivityReadContext);
    const { patient } = usePatientEpisodeCategoryContext();

    return (
        <>
            <ReadForm components={getExaminationRequestReadComponentsBase(readSections, processActivity.id)} />
            <HolterExaminationFollowingSteps holterType={CustomControlCode.HolterDirectExaminationRequest} />
            {processActivity.status === ProcessActivityStatus.complete && (
                <Box pt={4}>
                    <HolterConfigureSuccessAlert
                        holterDiaryUrl={getProcessActivityHolterDiaryUrl(processActivity.id, patient)}
                        recorderType={processActivity.customControlData.recorderType}
                    />
                    <FormButtonRow>
                        <Button
                            onClick={() => printDiary()}
                            variant="outline"
                        >
                            {getSelectedLanguage().holter.printDiary}
                        </Button>
                    </FormButtonRow>
                </Box>
            )}
        </>
    );

    function printDiary() {
        const url = getProcessActivityHolterDiaryUrl(processActivity.id, patient);
        window.open(url, '_blank');
    }
}
